module.exports = __webpack_public_path__ + "img/banner_store_2.f3022f79.png";